export default __webpack_public_path__ + "static/media/photo--lg--blitz-1.dc08a107.jpg";